import React, { useReducer, useEffect } from "react";

export class User {
  private _firstName: string;
  public get firstName(): string {
    return this._firstName;
  }
  public set firstName(value: string) {
    this._firstName = value;
  }

  private _lastName: string;
  public get lastName(): string {
    return this._lastName;
  }
  public set lastName(value: string) {
    this._lastName = value;
  }

  private _email: string;
  public get email(): string {
    return this._email;
  }
  public set email(value: string) {
    this._email = value;
  }

  private _role: Array<string>;
  public get role(): Array<string> {
    return this._role;
  }
  public set role(value: Array<string>) {
    this._role = value;
  }

  private _permissions: Array<string>;
  public get permissions(): Array<string> {
    return this._permissions;
  }
  public set permissions(value: Array<string>) {
    this._permissions = value;
  }

  private _organization: string;
  public get organization(): string {
    return this._organization;
  }
  public set organization(value: string) {
    this._organization = value;
  }

  public constructor(
    firstName = "John",
    lastName = "Doe",
    email = "john.doe@email.com",
    role = ["Test"],
    permissions = [""],
    organization = ""
  ) {
    this._firstName = firstName;
    this._lastName = lastName;
    this._email = email;
    this._role = role;
    this._permissions = permissions;
    this._organization = organization;
  }

  public isAuthorized(permission: string): boolean {
    if (this._permissions.includes(permission)) {
      return true;
    }
    return false;
  }

  public initialize(
    firstName: string,
    lastName: string,
    email: string,
    role: Array<string>,
    permissions = [""],
    organization: string
  ) {
    this._firstName = firstName;
    this._lastName = lastName;
    this._email = email;
    this._role = role;
    this._permissions = permissions;
    this._organization = organization;
  }
}
